export default {
  init() {

    function resizeSlideshow() {
      var window_width = $(window).width();
      var is_mobile = false;
      if (window_width <= 768) {
        is_mobile = true;
      }

      // set height of slick slideshow to window height - header height
      var window_height = $(window).height();
      var header_height = $('header.banner').outerHeight()

      // CH and Proof have a band that's outside the header that needs to be included in the calc
      // hard-coding height because it's set on a pseudoelement not selectable by js
      if ($('body').hasClass('restaurant-proof')) {
        header_height += 94; // 47 + bottom margin
      }
      if ($('body').hasClass('restaurant-countinghouse')) {
        header_height += 47;
      }
      if ($('body').hasClass('restaurant-poolbarokc')) {
        header_height += 100;
      }

      var slideshow_height = window_height - header_height;

      // mobile slideshows have different heights than desktop
      if (is_mobile) {
        slideshow_height = slideshow_height - 30;

        if ($('body').hasClass('restaurant-proof')) {
          slideshow_height = window_width;
        }
      }
      if ($('body').hasClass('restaurant-lockbox') || $('body').hasClass('restaurant-poolbarokc')) {
        if (is_mobile) {
          $(".slideshow-image").css('height', '35vh');
        } else {
          $(".slideshow-image").css('height', '65vh');
        }
      } else {
        $(".slideshow-image").css('height', slideshow_height + 'px');
      }

      // load appropriate slideshow image src based on browser width
      $.each($('.slideshow-image'), function( index, item ) {
        var src = is_mobile ? $(item).data('src-sm') : $(item).data('src-lg');
        $(item).css('background-image', 'url(' + src + ')');
      });
    }

    resizeSlideshow();
    window.addEventListener('resize', resizeSlideshow);

    // only enable slider if there's more than 1 slide
    if (document.querySelectorAll('.slideshow-image').length > 1) {
      // slideshow init
      $(".slideshow").slick({
        dots: true,
        arrows: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 6000,
        lazyLoad: 'ondemand'
      });
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js